document.addEventListener("click",(e)=>{

  const layer = e.target.closest(
    ".embroidery-text-layer,.embroidery-image-layer"
  );

  if(!layer) return;

  document
    .querySelectorAll(
      ".embroidery-text-layer,.embroidery-image-layer"
    )
    .forEach(el=>el.classList.remove("active-object"));

  layer.classList.add("active-object");

  window.selectedEmbroideryLayer = layer;

});